// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3m4Uk","alert":"SettungsInbox_alert__3b7c0"};